import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ParamMap } from '@angular/router';

@Injectable()
export class RouteParamService {

  constructor() {}

  public getId(route: ActivatedRouteSnapshot, paramName: string, includeParents: boolean = true): number {
    const param = route.paramMap.get(paramName);
    if (!param && includeParents && route.parent) {
      return this.getId(route.parent, paramName, true);
    }
    let id = 0;
    if (param !== null) {
      id = parseInt(param, 10);
    }
    return id;
  }

  public getCurrentRouteId(paramMap: ParamMap, paramName: string): number {
    const param = paramMap.get(paramName);
    let id = 0;
    if (param !== null) {
      id = parseInt(param, 10);
    }

    return id;
  }
}

